var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('Main',{staticClass:"col-md-8 pr-0"}),_c('Side',{staticClass:"col-md-4 pr-0"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }